<template>
  <div class="personal_commen">
    <header>
      <div class="w_d">
        <PersonalHeader :webUserInfo="webUserInfo"></PersonalHeader>
      </div>
    </header>

    <MyBreadCrumb
      v-if="$route.path !== '/personalheader' && $route.path !== '/nowtopay'"
      :is_index="false"
    ></MyBreadCrumb>
    <section>
      <div class="w_d both clearfix">
        <!-- 左 -->
        <div class="menu">
          <!-- 1教师 2校培 3县培 4市培 5校管理员 -->
          <Menu v-if="role == 1"></Menu>
          <SchoolTrainMenu v-else-if="role == 2"></SchoolTrainMenu>
          <AreaTrainMenu v-else-if="role == 3 || role == 4"></AreaTrainMenu>
          <SchoolMngMenu v-else-if="role == 5"></SchoolMngMenu>
        </div>
        <!-- 右 -->
        <div class="content">
          <!-- <keep-alive include="keepAlive"> -->
            <router-view></router-view>
          <!-- </keep-alive> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webUserInfo: {},
      is_pay: false,
      abilityTestData: {},
      role: "", //1教师 2校培 3县培 4市培 5校管理员
      testName:''
    };
  },
  methods: {
    // changeVal(val) {
    //   this.testName = val;
    // },
  
  },
  created() {
    // 获取用户信息
    let webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    if (webUserInfo) {
      this.webUserInfo = webUserInfo;
      let { role } = this.webUserInfo;
      this.role = role;
    }
  },
};
</script>

<style lang="less" scoped>
.personal_commen {
  header {
    height: 210px;
    background: url("../../assets/images/成果认定/banner.png") no-repeat center
      center;
    position: relative;
  }
  section {
    background-color: #f7f7f7;
    padding-bottom: 68px;
    .both {
      // display: flex;
      // justify-content: space-between;
      .menu {
        float: left;
      }
      .content {
        width: 976px;
        // margin-left: 24px;
        float: right;
      }
    }
  }
}
</style>
